import { Button } from "components/DesignSystem/Button/Button";
import { ChartHistogram } from "components/icons/ChartHistogram";
import { useToast } from "hooks/useToast";
import { useEnrollSelfMutation } from "store/apis/estimatedTax";
import { BackendError } from "types/utils/error";

type Props = {
  entityId: string;
};

export const EstimatedTaxEmptyState = ({ entityId }: Props) => {
  const { alertToast, successToast } = useToast();
  const [enrollSelf, { isLoading }] = useEnrollSelfMutation();

  const handleSelfDeclare = async () => {
    try {
      await enrollSelf({ entityId }).unwrap();
      successToast({ message: "Estimated tax activated for your entity" });
    } catch (e) {
      alertToast({
        message:
          (e as BackendError)?.data?.error?.message ||
          "Failed to activate estimated tax",
      });
    }
  };

  return (
    <div className="t-flex t-flex-col t-items-center t-justify-center t-py-20 t-gap-6 t-text-center">
      <div className="t-w-16 t-h-16 t-rounded-full t-bg-surface-lighter-grey t-flex t-items-center t-justify-center">
        <ChartHistogram width="25" height="25" />
      </div>
      <div className="t-max-w-md t-space-y-2">
        <h2 className="t-text-subtitle t-font-semibold t-text-text-100">
          Estimated Tax Not Active
        </h2>
        <p className="t-text-body-sm t-text-text-30">
          Estimated tax calculations are available once your entity is
          profitable. Your bookkeeper will activate this automatically when your
          books show profit, or you can self-declare below.
        </p>
      </div>
      <Button
        customType="primary"
        isLoading={isLoading}
        disabled={isLoading}
        onClick={handleSelfDeclare}
      >
        I am profitable — activate estimated tax
      </Button>
    </div>
  );
};
